import React, { useState } from 'react';
import { Formik, Form, Field } from 'formik';
import { Button, Input } from 'reactstrap';
import PropTypes from 'prop-types';
import { useMutation, useQueryClient } from 'react-query';
import { infobankTypes } from 'common/data/InfoBankTypes';
import { addInfoBankNewInformation } from 'helpers/fakebackend_helper';
import * as Yup from 'yup';




const DocumentCreatForm = ({ onClose }) => {

  const [files, setFiles] = useState([]);
  const queryClient = useQueryClient();
  const { mutate: addDocumentMutate, isLoading: isAddDocumentLoading } = useMutation(addInfoBankNewInformation);

  const addDocument = (values, { resetForm }) => {
    const formData = new FormData();
    formData.append('name', values.name);
    files.forEach((file, index) => {
      formData.append(`document_files[${index}]`, file);
    });
    formData.append('info_type', values.infoType);
    formData.append('item_type', 'document');

    addDocumentMutate(formData, {
      onSuccess: () => {
        queryClient.invalidateQueries('infoBank');
        resetForm();
        setFiles([])
        onClose()
      }
    });
  };

  const documentSchema = Yup.object().shape({
    name: Yup.string().required('Document name is required'),
    infoType: Yup.string().required('Information type is required'),
  });


  return (
    <Formik
      initialValues={{ name: '', infoType: '' }}
      validationSchema={documentSchema}
      onSubmit={addDocument}
    >
      {() => (
        <Form id='add-new-document'>
          <h5 className="mb-4">Add New Document</h5>
          <div className="d-flex justify-content-between mb-2">
            <label className="mr-2">Information Type:</label>
            <Field as="select" name="infoType" style={{ width: '50%' }} className="form-control">
              <option value="" disabled>Select Information Type</option>
              {infobankTypes.map((type, index) => (
                <option key={index} value={type}>{type}</option>
              ))}
            </Field>
            {/* <ErrorMessage name="infoType" component="div" className="text-danger" /> */}
          </div>
          <div className="d-flex justify-content-between mb-2">
            <label className="mr-2">Document Name:</label>
            <Field
              name="name"
              placeholder="Document Name"
              style={{ width: '50%' }}
              className="form-control"
            />
            {/* <ErrorMessage name="name" component="div" className="text-danger" /> */}
          </div>
          <div className="d-flex justify-content-between mb-2">
            <label className="mr-2">Documents :</label>
            <Input type="file"
              onChange={(e) => setFiles(Array.from(e.target.files))}
              multiple
              style={{ width: '50%' }}
            />
            {/* <ErrorMessage name="location" component="div" className="text-danger" /> */}
          </div>
          <div className="d-flex justify-content-end mt-3">
            <Button color="primary" style={{ backgroundColor: "#2F8C47", width: '50%'  }}   type="submit" disabled={isAddDocumentLoading}>
              {isAddDocumentLoading ? <i className="fa fa-spinner fa-spin mr-2" aria-hidden="true"></i> : <i className="fa fa-plus mr-2" aria-hidden="true"></i>} Add Document
            </Button>
          </div>
        </Form>
      )}
    </Formik>
  );
}

DocumentCreatForm.propTypes = {
  onClose: PropTypes.func.isRequired
};

export default DocumentCreatForm;
